import { render } from "./CreditsModal.vue?vue&type=template&id=f8b57d04&scoped=true"
import script from "./CreditsModal.vue?vue&type=script&lang=js"
export * from "./CreditsModal.vue?vue&type=script&lang=js"

import "./CreditsModal.vue?vue&type=style&index=0&id=f8b57d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b57d04"]])

export default __exports__